const DurationHelper = (seconds) => {
  let duration = [
    Math.floor(seconds / 3600),
    Math.floor((seconds / 60) % 60),
    seconds % 60,
  ];

  return {
    full: (() => {
      return duration
        .reduce((prev, curr) => {
          let val = curr.toString();

          return `${prev}:${val.length <= 1 ? "0" + val : val}`;
        }, "")
        .substring(1);
    })(),
    shorten: (() => {
      return duration
        .reduce((prev, curr, index) => {
          if (index === 0 && curr === 0) {
            return prev;
          }
          let val = curr.toString();

          return `${prev}:${val.length <= 1 ? "0" + val : val}`;
        }, "")
        .substring(1);
    })(),
    simple: (() => {
      const [hour, minute] = duration;
      let dur = hour ? `${hour} jam ` : "";
      dur += minute ? `${minute} menit` : hour ? "" : "< 1 menit";

      return dur;
    })(),
  };
};

export { DurationHelper };
